(() => {
  if (customElements.get('akbar-whatsapp-chat')) return;
  class WhatsAppChat extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      if (!this.link) return;
      this.events = new AbortController();
      this.link.addEventListener('click', () => this.updateLink(), { signal: this.events.signal });
      this.updateLink();
    }

    updateLink() {
      const phone = this.dataset.phone.replace(/\D/g, '');
      let message = this.dataset.message || '';
      if (this.dataset.includePage === 'true') {
        // Share the selected product variant, without preview tokens or tracking parameters.
        const current = new URL(location.href);
        const page = new URL(current.pathname, current.origin);
        if (current.searchParams.has('variant')) page.searchParams.set('variant', current.searchParams.get('variant'));
        message += '\n\n' + page.href;
      }
      this.link.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(message);
    }

    disconnectedCallback() { this.events?.abort(); }
  }
  customElements.define('akbar-whatsapp-chat', WhatsAppChat);
})();
